import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { color } from "../../../StyleData/Config";
import { Clear } from "@mui/icons-material";
import NormalTable from "../../../Component/NormalTable";

const LabourView = ({data, handleCloseClick}) => {
  const [personDetail, setPersonDetail] = useState({});
  const [craftDetail, setCraftDetail] = useState([]);
console.log('data',data)
  useEffect(() => {
   getData()
  }, []);

  const getData=async()=>{
    const personLink = masterAPI["person"].getByid;
   await axiosPrivate
      .get(`${personLink}/${data.personId}`)
      .then((res) => {
        setPersonDetail(res.data.result);
      })
      .catch((e) => {
        setPersonDetail({});
        console.log(e);
      });
    const craftLink = masterAPI["labourCraft"].craftBylabour;
   await axiosPrivate(`${craftLink}/${data.id}`)
      .then((res) => {
        setCraftDetail(res.data.result);
      })
      .catch((e) => {
        setCraftDetail([]);
        console.log(e);
      });
  }

  const columns = [
    {
      Header: "Code",
      accessor: "craftCode",
    },
    {
      Header: "Craft Name",
      accessor: "craftName",
    },
  ];

  return (
    <Box sx={{p: color.masterPageDialogPadding}}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {data.code + "-" + data.labourName}
        </Typography>
        <IconButton onClick={handleCloseClick}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Grid container spacing={"1rem"}>
              <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Labour Code
                </Typography>
                <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {data.code}
              </Typography>
               
                </Grid>
                <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Labour Name
                </Typography>
                <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {data.labourName}
              </Typography>
               
                </Grid>
                <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Person Code
                </Typography>
                <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {personDetail.code}
              </Typography>
               
                </Grid>
                <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Person Name
                </Typography>
                <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {personDetail.personName}
              </Typography>
               
                </Grid>
                <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Email
                </Typography>
                <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {personDetail.email}
              </Typography>
               
                </Grid>
                <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Mobile No
                </Typography>
                <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {personDetail.mobileNo}
              </Typography>
              <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift
                </Typography>
                <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {data.shiftName}
              </Typography>
               
                </Grid>
                </Grid>
                <Grid item xs={12} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Crafts
                </Typography>
               
                <NormalTable data={craftDetail} columns={columns}/>
               
                </Grid>
      </Grid>
    </Box>
  );
};

export default LabourView;
